import { Injectable } from '@angular/core';
import { AppServiceService } from './app-service.service';
import { WindowService } from './window.service';
declare var jQuery: any;
declare var sliderEffect: any;
declare var google: any;
declare var MarkerClusterer: any;
declare var api_settings: any;
declare var lightbox:any;


@Injectable()
export class UiService {
  private lastY:number = 0;
  private moveUp:boolean = false;
  private stopScroll: boolean = false;
  private animateProcess = false;
  public change = false;

  constructor(private app: AppServiceService, private window: WindowService) { }

  animateProcessFunc(){
    
    this.animateProcess = true;
    setTimeout(() => {
      this.animateProcess = false;
    }, 800)
  }

  leftPanelSingleCollection(){
    jQuery('body').on('click','.menu-open', () => {
      if(jQuery('app-post-collection, app-custom-order')[0]){
        this.app.logoWhite.next(false);
        this.app.transparent.next(false);
        this.app.arrow.next(false);
        this.app.showLeftPanel.next(true);
        setTimeout(() => {
          this.app.titleLeftPanel.next(true);
        }, 500);
      }
    });

    jQuery('body').on('click','.close-menu', () => {
      if(jQuery('app-post-collection, app-custom-order')[0]){
        this.app.titleLeftPanel.next(false);
        setTimeout(() => {
          this.app.logoWhite.next(true);
          this.app.transparent.next(true);
          this.app.arrow.next(true);
          this.app.showLeftPanel.next(true);
        }, 500);
      }
    });
    
  }


  /**
   * fair trade page slider init
   */
  fairTradeSlider() {
    let slider;
    if(!this.widthMobile()){
      slider = jQuery('.content-slide .slider').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        speed: 800,
        touchMove: false,
        arrows: false,
        rows: 2,
        dots: true,
        responsive: [
          {
            breakpoint: 800,
            settings: {
              rows: 1,
              slidesToShow: 1,
            }
          },
        ]
      });
    }else{
      slider = jQuery('.content-slide .slider').slick({
        infinite: false,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        touchMove: false,
        rows: 1,
        dots: true,
      });
    }
    
    //event slider
    jQuery('.content-slide .slider').on('wheel', function(e){
      var deltaY = e.originalEvent.deltaY;
      var deltaX = e.originalEvent.deltaX;
      if(deltaY > 0 || deltaX > 0){
        //move down
        slider.slick('slickNext');
      }else{
        //move up
        slider.slick('slickPrev');
      }
      return false;
    });
  }

  styleSelect() {
    jQuery('.selectpicker').selectpicker({'dropupAuto' : false});
  }

  /**
   * slider in collection page
   */
  slideCollection(article, home = false, status = false) {
    let slider;
    slider = jQuery(article).slick({
      infinite: false,
      centerMode: false,
      speed: 800,
      slidesToShow: 3,
      variableWidth: true,
      useCSS: true,
      touchMove: false,
      responsive: [
        {
          breakpoint: 1400,
          settings: {
            slidesToShow: 3
          }
        },
        {
          breakpoint: 1050,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 750,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 440,
          settings: {
            slidesToShow: 1
          }
        }
      ]
    });
    if(!this.widthMobile()){
      //event slider
      jQuery(article).on('wheel', (e) => {
        if(jQuery('#second')[0]){
          if(!jQuery('#second').hasClass('active-section')){
            return false;
          }
        }
        var deltaY = e.originalEvent.deltaY;
        var deltaX = e.originalEvent.deltaX;
        if(this.animateProcess){
          return false;
        }
        if(deltaY > 0 || deltaX > 0){
          //move down
          this.animateProcessFunc();
          slider.slick('slickNext');
        }else{
          //move up
          this.animateProcessFunc();
          slider.slick('slickPrev');
          
        }
        return false;
      });
    }

    //chack section active
    if (home) {
      jQuery('.arrow-left').on('click', () => {
        if (jQuery('.active-section').hasClass('sec-2')) {
          slider.slick('slickPrev');
        }
      });
      jQuery('.arrow-right').on('click', () => {
        if (jQuery('.active-section').hasClass('sec-2')) {
          slider.slick('slickNext');
        }
      });
    } else {
      jQuery('.arrow-left').on('click', () => {
        slider.slick('slickPrev');
      })
      jQuery('.arrow-right').on('click', () => {
        slider.slick('slickNext');
      })
    }
  }

  /**
   * active carper slider
  */

  activeCarpet(){
    jQuery('.scroll-area').click();
  }

  /**
   * slider in designers page
   */
  slideDesigners() {
    var slider = jQuery('.designers-slider').slick({
      centerMode: false,
      infinite: false,
      centerPadding: '100px',
      slidesToShow: 4,
      speed: 700,
      variableWidth: true,
      touchMove: false,
      responsive: [
        {
          breakpoint: 1440,
          settings: {
            slidesToShow: 5
          }
        },
        {
          breakpoint: 440,
          settings: {
            slidesToShow: 1
          }
        },
      ]
    });
    //event slider
    jQuery('.designers-slider').on('wheel', function(e){
      var deltaY = e.originalEvent.deltaY;
      var deltaX = e.originalEvent.deltaX;
      if(deltaY > 0 || deltaX > 0){
        //move down
        slider.slick('slickNext');
      }else{
        //move up
        slider.slick('slickPrev');
      }
      return false;
    });
  }

  /**
   * video style player
   */
  mediaScript(){
    jQuery('video').each(function(){
      var id = '#' + jQuery(this).attr('id');
      jQuery(id).mediaelementplayer({
        pauseOtherPlayers: false,
        stretching: 'responsive',
        autoplay: true,
        muted: true,
        loop: true,
        //youtube: 'maxresdefault',
        success: function(mediaElement, originalNode, instance) {
          mediaElement.play();
          originalNode.muted = true;
        }
      })
    })
  }

  /**
   * menu script 
   */
  menuScripts(){
    jQuery('.fullmenu .menu li .inside').on('mouseenter', function(){
      jQuery(this).parent().addClass('active-event');
      if(jQuery(this).hasClass('parent')){
        jQuery(this).parent().addClass('children-event');
        jQuery(this).parent().parent().addClass('parent-event');
        jQuery(this).parent().addClass('event');
      }
      
    });
    jQuery('.fullmenu .menu li').on('mouseleave', function(){
      jQuery(this).removeClass('children-event');
      jQuery(this).removeClass('active-event');
      //
      jQuery(this).parent().removeClass('parent-event');
      jQuery(this).removeClass('event');

    })
  }

  /**
   * remove bug
   */

   removeSvgMask(){
     jQuery('#circle-collection-post').remove();
   }

  /**
   * text slider init
   * @param nameSlider selector slider init
   */
  textSlider(nameSlider) {
    let slider;
    var slick = {
      centerMode: false,
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      speed: 700,
      touchMove: false,
      arrows: false,
      dots: true,
      fade: true,
      cssEase: 'linear'
    };
    //chack has background-slider or not
    if(jQuery('.slider-images')[0]){

      slick['asNavFor'] = '.slider-images';
      jQuery('.slider-images').slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        fade: true,
        cssEase: 'linear',
        touchMove: false,
        infinite: false,
        speed: 700,
        asNavFor: nameSlider,
      });
    }
    slider = jQuery(nameSlider).slick(slick);

    //event slider
    jQuery(nameSlider).on('wheel', function(e){
      var deltaY = e.originalEvent.deltaY;
      var deltaX = e.originalEvent.deltaX;
      if(deltaY > 0 || deltaX > 0){
        //move down
        slider.slick('slickNext');
      }else{
        //move up
        slider.slick('slickPrev');
      }
      return false;
    });

    if(this.widthMobile()){
      //mobile change
      jQuery(nameSlider).on('touchstart', (event) => {
        this.lastY = event.originalEvent.touches[0].clientY + 80;  
        if(jQuery(event.currentTarget).hasClass('scroll-up-block')){
          if(!jQuery(event.currentTarget).hasClass('scroll-up-catived')){
            this.moveUp = true;
          }
        }
      });

      jQuery(nameSlider).on('touchmove', (event) => {
        if(this.stopScroll){
          return false;
        }
        var currentY = event.originalEvent.touches[0].clientY;
          if(currentY > this.lastY){
            //slider.slick('slickPrev');
          }else if(currentY < this.lastY){
            if(this.moveUp){
              this.moveUp = false;
              jQuery(event.currentTarget).prev().addClass('scroll-up-catived');
              jQuery(event.currentTarget).addClass('scroll-up-catived');
              this.stopScroll = true;
              setTimeout(() => {
                this.stopScroll = false;
              }, 1000);
              return false;
            }
          }
      });
    }

    jQuery('.arrow-left').on('click', () => {
      slider.slick('slickNext');
    });
    jQuery('.arrow-right').on('click', () => {
      slider.slick('slickPrev');
    });
  }

  addSliderFairTrade(){
    jQuery('.content-slide').addClass('scroll-sec');
  }

  /**
   * scroll style block text
   */

  scrollStyleBlock(){
    if(this.widthMobile()){
      //mobile change
      jQuery('.scroll-up-block').on('touchstart', (event) => {
        this.lastY = event.originalEvent.touches[0].clientY + 80;  
        if(!jQuery(event.currentTarget).hasClass('scroll-up-catived')){
          this.moveUp = true;
        }
      });

      jQuery('.scroll-up-block').on('touchmove', (event) => {
        if(this.stopScroll){
          return false;
        }
        var currentY = event.originalEvent.touches[0].clientY;
          if(currentY > this.lastY){
            //slider.slick('slickPrev');
          }else if(currentY < this.lastY){
            if(this.moveUp){
              this.moveUp = false;
              jQuery(event.currentTarget).prev().addClass('scroll-up-catived');
              jQuery(event.currentTarget).addClass('scroll-up-catived scroll-sec');
              this.stopScroll = true;
              setTimeout(() => {
                this.stopScroll = false;
              }, 1000);
              return false;
            }
          }
      });
    }
  }

  /**
   * get width block
   */

   getWidth(){
    return jQuery('body').innerWidth() > 1050 ? true : false;
   }

   /*
    * Name: removePreloader
    * destroy reloader, when page is ready
    * @params {pageReady} - bool value, true, when page is ready
    */
  removePreloader(){
    jQuery('.preloader-field').addClass('remove-preloader');
    setTimeout(() => {
      jQuery('.preloader-field').addClass('hidden');
    }, 2000);
  }

    /*
    * Name: activePreloader
    * destroy reloader, when page is ready
    * @params {pageReady} - bool value, true, when page is ready
    */
  activePreloader(){
    jQuery('.preloader-field').removeClass('remove-preloader');
    jQuery('.preloader-field').removeClass('hidden');
  }

  /**
  * mobile slider carpet
  */
  sliderCarpet(){
    if(this.widthMobile()){
      jQuery('.list-block-carpet .scroll-area').slick({
        centerMode: true,
        centerPadding: '70px',
        arrows: false,
        infinite: true,
        touchMove: false,
        slidesToShow: 1,
      });
    }
  }

  /**
  * get width block
  */

  widthMobile(){
    return jQuery('body').innerWidth() < 500 ? true : false;
  }

  /**
   * blog slider 
   */
  sliderBlog() {
    let slider;
    slider = jQuery("#blog-page .content .inside").slick({
      centerMode: false,
      infinite: false,
      centerPadding: '100px',
      slidesToShow: 3,
      arrows: false,
      touchMove: false,
      responsive: [
        {
          breakpoint: 1050,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1
          }
        },
        {
          breakpoint: 440,
          settings: {
            slidesToShow: 1,
            centerPadding: '40px'
          }
        },
      ]
    });
    //event slider
    jQuery("#blog-page .content .inside").on('wheel', function(e){
      var deltaY = e.originalEvent.deltaY;
      var deltaX = e.originalEvent.deltaX;
      if(deltaY > 0 || deltaX > 0){
        //move down
        slider.slick('slickNext');
      }else{
        //move up
        slider.slick('slickPrev');
      }
      return false;
    });
    jQuery('.arrow-left').on('click', () => {
      slider.slick('slickPrev');
    })
    jQuery('.arrow-right').on('click', () => {
      slider.slick('slickNext');
    })
  }
  sliderBlogDestroy() {
    jQuery("#blog-page .content .inside").slick('unslick');
  }

  /**
   * add specific class
   */

  activeVisBlock(){
    jQuery('.content-text .item').addClass('active-block');
  }

  /**
   * show done model contact send
  */
  showContactModalSend(){
    jQuery('#messageSend').modal('show');
    setTimeout(() => {
      jQuery('#messageSend').modal('hide');
    }, 5000);
  }

  /**
   * slider colection
  */
  sliderCollectionPost(){
    let slider;
    slider = jQuery(".collection-post .slider-images-bg").slick({
      centerMode: false,
      infinite: false,
      slidesToShow: 1,
      arrows: false,
      speed: 800,
      touchMove: false,
      responsive: [
        {
          breakpoint: 440,
          settings: {
            autoplay: true,
            autoplaySpeed: 6000
          }
        },
      ]
    });
    jQuery('.arrow-left').on('click', () => {
      slider.slick('slickPrev');
    })
    jQuery('.arrow-right').on('click', () => {
      slider.slick('slickNext');
    })
  }

  /**
   * press slider 
   */
  sliderPress() {
    let slider;
    slider = jQuery("#press-page .content .inside").slick({
      centerMode: false,
      infinite: false,
      centerPadding: '100px',
      slidesToShow: 3,
      arrows: false,
      variableWidth: true,
      touchMove: false,
      responsive: [
        {
          breakpoint: 1050,
          settings: {
            slidesToShow: 2
          }
        },
        {
          breakpoint: 900,
          settings: {
            slidesToShow: 1
          }
        },
      ]
    });
    //event slider
    jQuery("#press-page .content .inside").on('wheel', function(e){
      var deltaY = e.originalEvent.deltaY;
      var deltaX = e.originalEvent.deltaX;
      if(deltaY > 0 || deltaX > 0){
        //move down
        slider.slick('slickNext');
      }else{
        //move up
        slider.slick('slickPrev');
      }
      return false;
    });
    jQuery('.arrow-left').on('click', () => {
      slider.slick('slickPrev');
    })
    jQuery('.arrow-right').on('click', () => {
      slider.slick('slickNext');
    })
  }

  sliderPressDestroy() {
    jQuery("#press-page .content .inside").slick('unslick');
  }

  /**
   * caret event in menu
   */

  menuCaret(){
    jQuery('body').on('click','.menu-caret', function(){
      jQuery(this).toggleClass('active');
      jQuery(this).next().slideToggle();
    });
  }

  /**
   * main slider home page
   */
  mainHomeSlider() {

    Array.from(document.querySelectorAll('.grid__item-img')).forEach((el:any) => {
      const imgs = Array.from(el.querySelectorAll('img'));
      new sliderEffect({
        parent: el,
        intensity: el.dataset.intensity || undefined,
        speedIn: el.dataset.speedin || undefined,
        speedOut: el.dataset.speedout || undefined,
        easing: el.dataset.easing || undefined,
        hover: el.dataset.hover || undefined,
        images: imgs,
        displacementImage: el.dataset.displacement
      });
    });

    jQuery('.arrow-left').on('click',() => {
      if(jQuery('.active-section').hasClass('sec-1')){
        jQuery('#next-button').click();
      }
    })
    jQuery('.arrow-right').on('click',() => {
      if(jQuery('.active-section').hasClass('sec-1')){
        jQuery('#previous-button').click();
      }     
    })
  }

  /**
   * Get width left panel
  */
  getWidthPanel(){
    jQuery(window).on('resize', (el) => {
      let width = Math.ceil(jQuery('.left-side-block').outerWidth());
      this.app.widthPanelLeft = width;
    });
    let width = Math.ceil(jQuery('.left-side-block').outerWidth());
    this.app.widthPanelLeft = width;
  }

  /**
   * change color menu
   */
  blackMenu() {
    this.app.blackStyle.next(true);
  }
  whiteMenu() {
    this.app.blackStyle.next(false);
  }

  /**
   * mobile click menu
   */

  mobileclickMenu(){
    jQuery('body').on('click', '.menu-open',() => {
      this.app.menuState.next('show');
    });
   }

   moveHomeSection(){
    this.app.menuState.next('hide');
    jQuery('.scroll-span').removeClass('show');
    this.app.blackStyle.next(true);
    setTimeout(() => {
      this.app.showLeftPanel.next(true);
      this.app.titleLeftPanel.next(true);
      this.app.activeMenu.next(true);
    }, 400);
    setTimeout(() => { 
      this.app.stateSlider.next('normal');
      this.window.removeMainSlider();
    }, 1200)
    jQuery('.nav-menu').fadeIn();
    jQuery('.scroll-span').fadeOut();
    jQuery('#social').fadeIn();

    var destination = jQuery('#second').offset().top;
    jQuery('#second').addClass('active-section');
    jQuery("html:not(:animated),body:not(:animated)").animate({ scrollTop: destination }, 900);


    
   }

   /**
    * active lightbox
    */

    lightbox(){
      lightbox.option({
        'resizeDuration': 200,
        'wrapAround': true
      })
    }


  /**
   * home page script init
   */
  
  scrollEventHome() {
    //let change = false;

    // show first block
    function showFirstHome(app, change){
      this.change = true;
      setTimeout(() => {
        //stop scroll
        this.change = false;
      }, 1000);
      jQuery('.scroll-span').removeClass('show');
      app.activeMenu.next(true);
      jQuery('.scroll-span').fadeOut();
      jQuery('#social').fadeIn();
      //active left panel
      app.showLeftPanel.next(true);
      app.titleLeftPanel.next(true);
      return false;
    }

    //show animate block
    function animateBlock(id, app){
      var destination = jQuery('#' + id).offset().top;
      jQuery("html:not(:animated),body:not(:animated)").animate({ scrollTop: destination }, 900);
      setTimeout(() => {
        jQuery('#' + id).addClass('active-section');
        if(jQuery('.active-section').attr('id') == 'second') {
          app.blackStyle.next(true);
          app.stateSlider.next('normal');
          location.hash= '#home';
        }else{
          app.blackStyle.next(false);
          app.stateSlider.next('hide');
          location.hash= '';
        }
      }, 1000);
    }

    //function change block
    function changeBlock(bool){
      let id;
      if (bool) {
        if (jQuery('.active-section').prev()[0]) {
          id = jQuery('.active-section').removeClass('active-section').prev().attr('id');
        }
      } else {
        if (jQuery('.active-section').next()[0]) {
          id = jQuery('.active-section').removeClass('active-section').next().attr('id');
        }
      }

      return id;
    }

    jQuery('.scroll-span').on('click', () => {
      this.change = true;
      setTimeout(() => {
        //stop scroll
        this.change = false;
      }, 1000);
      jQuery('.scroll-span').removeClass('show');
      this.app.activeMenu.next(true);
      jQuery('.scroll-span').fadeOut();
      jQuery('#social').fadeIn();
      //active left panel
      this.app.showLeftPanel.next(true);
      this.app.titleLeftPanel.next(true);
      return false;
    });
    if(!this.widthMobile()){
      jQuery('.home-page').on('wheel', (event) => {
        //if animate process
        if (this.change) {
          return false;
        }
        //if first display not init
        if (jQuery('.scroll-span').hasClass('show')) {
          this.change = true;
          setTimeout(() => {
            //stop scroll
            this.change = false;
          }, 1000);
          jQuery('.scroll-span').removeClass('show');
          this.app.activeMenu.next(true);
          jQuery('.scroll-span').fadeOut();
          jQuery('#social').fadeIn();
          //active left panel
          this.app.showLeftPanel.next(true);
          this.app.titleLeftPanel.next(true);
          return false;
        }
        event.preventDefault();

        let id = changeBlock(event.originalEvent.wheelDelta >= 0);
        if (!id) {
          return false;
        }
        if(id != 'first'){
          animateBlock(id, this.app);
        }
        

      });
    }else{

      //document.window.requestFullscreen();
      jQuery('.home-page').on('touchstart', (event) => {
          this.lastY = event.originalEvent.touches[0].screenY + 80;
          
      });

      jQuery('.home-page').on('touchmove', (event) => {
        //if animate process
        if (this.change) {
          return false;
        }
        //if first display not init
        if (jQuery('.scroll-span').hasClass('show')) {
          this.change = true;
          setTimeout(() => {
            //stop scroll
            this.change = false;
          }, 1000);
          jQuery('.scroll-span').removeClass('show');
          this.app.activeMenu.next(true);
          jQuery('.scroll-span').fadeOut();
          jQuery('#social').fadeIn();
          //active left panel
          this.app.showLeftPanel.next(true);
          this.app.titleLeftPanel.next(true);
          return false;
        }
        event.preventDefault();

        let id = changeBlock(event.originalEvent.touches[0].screenY > this.lastY);

        if (!id) {
          return false;
        }

        animateBlock(id, this.app);
      })
    }
  }


  /*
  * google map 
  */

  initMap(data) {
    let first;
    if(data){
        if(data.length > 0){
            first = {lat: +data[0].latitude, lng: +data[0].longitude};
        }else{
            first = {lat: 20.345750, lng: 6.193636};
        }                    
    }else{
        first = {lat: 20.345750, lng: 6.193636};
    }
    
    let bounds  = new google.maps.LatLngBounds();
    
    let map = new google.maps.Map(document.getElementById('map'), {
      zoom: 17,      
      center: first,
      disableDefaultUI: true,
      zoomControl: true,
      mapTypeId: google.maps.MapTypeId.ROADMAP,
      styles: [
                {
                    "featureType": "administrative",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#444444"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#f2f2f2"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 45
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "labels.icon",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "all",
                    "stylers": [
                        {
                            "color": "#4f595d"
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                }
            ]
    }); 

    map.setOptions({ minZoom: 2, maxZoom: 18 });

    if(data){

        var locations = [];
        var markers = [];
        var labels = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';

        data.forEach(function(el){    
          
            if(el.geo_lication.lng && el.geo_lication.lat){
              var marker = new google.maps.Marker({
                  position: {lat: +el.geo_lication.lat, lng: +el.geo_lication.lng},
                  center: {lat: +el.geo_lication.lat , lng: +el.geo_lication.lng},
                  icon: api_settings.template + '/dist/assets/images/pin.png',
                  map: map
              });

              markers.push(marker); 


              (function (marker, info) {

                  var contentString =
                  '<div id="content">\n' +
                  '\t<div id="siteNotice" class="content-map">\n' +
                  '\t\t<p>\n' +
                  '\t\t<h2><b>' + info.title + '</b></h2><br/>\n' +
                  '\t\tAddress:  <b>' + info.address[0]['adress_line'] +'</b><br/>\n' +
                  (info.phone ? '\t\tPhone:  <b>' + info.phone +'</b><br/>\n' : '') +
                  (info.web_site[0] ? '\t\tWebsite:  <b><a target="_black" href="'+info.web_site[0]['url']+'">'+info.web_site[0]['url']+'</a></b>\n': '') +
                  '\t\t</p>\n' +
                  '\t</div>\n' +
                  '</div>';

                  var infowindow = new google.maps.InfoWindow({
                      content: contentString
                  });

                  google.maps.event.addListener(marker, 'click', function() {
                      jQuery('.gm-style-iw').next().click();
                      infowindow.open(map, marker);
                  });
                  
                  let loc = new google.maps.LatLng(marker.position.lat(), marker.position.lng());
                  bounds.extend(loc);

                  google.maps.event.addListener(infowindow, 'domready', function() {

                      var iwOuter = jQuery('.gm-style-iw');

                      var iwBackground = iwOuter.prev();

                  });


              })(marker, el);    
          }

        });

        var clusterStyles = [
            {
                textColor: 'white',
                url: api_settings.template + '/dist/assets/images/m2.png',
                height: 55,
                width: 41,
                anchor:[7,50]
            },
            {
                textColor: 'white',
                url: api_settings.template + '/dist/assets/images/m2.png',
                height: 55,
                width: 41,
                anchor:[7,50]
            },
            {
                textColor: 'white',
                url: api_settings.template + '/dist/assets/images/m2.png',
                height: 55,
                width: 41,
                anchor:[7,50]
            }
        ];

        var mcOptions = {                   
            gridSize: 50,
            styles: clusterStyles,
            maxZoom: 9
        };
        
        map.fitBounds(bounds);
        map.panToBounds(bounds); 

        var markerCluster = new MarkerClusterer(map, markers, mcOptions);

    }
  }

  hexToRgb(hex:string) {
    if(!hex){
      return '0,0,0';
    }
    let shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
    hex = hex.replace(shorthandRegex, function(m, r, g, b) {
        return r + r + g + g + b + b;
    });

    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return parseInt(result[1], 16) + ',' + parseInt(result[2], 16) + ',' + parseInt(result[3], 16);
  }

  getShadow(hex:string){
    let rgb = this.hexToRgb(hex);
    let shadow;

    if(this.widthMobile()){
      shadow = '0px 20px 60px 0px rgba('+rgb+', 1)';
    }else{
      shadow = '0px 20px 120px 0px rgba('+rgb+', 1)';
    }

    return shadow;
  }

  animateDownBlog(){
    var destination = jQuery('#content-post').offset().top;
    jQuery(".post-page").animate({ scrollTop: destination }, 900);
  }

  /**
   * get screen 
  */
  getScreenParams(){
    jQuery(window).on('resize', (el) => {
      let screen = {
        'width' : Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
        'height' :  Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
      };
      if(this.widthMobile()){
        screen.height += 110;
        screen.width  += 40;
      }
      this.app.screen = screen;
      this.app.screenSubject.next(true);
    });
    let screen = {
      'width' : Math.max(document.documentElement.clientWidth, window.innerWidth || 0),
      'height' :  Math.max(document.documentElement.clientHeight, window.innerHeight || 0)
    };
    if(this.widthMobile()){
      screen.height += 110;
      screen.width  += 40;
    }
    this.app.screen = screen;
    this.app.screenSubject.next(true);
  }
}



// WEBPACK FOOTER //
// ./src/app/ui.service.ts